import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider.jsx'

// Friendly labels for the role tokens RequireRole passes through. Keeps
// the message defensible ("restricted to platform administrators") and
// avoids the older wording's implication that the role might gain
// access in a future build.
const ROLE_LABELS = {
  admin:           'platform administrators',
  doctor:          'doctors',
  specialist:      'specialists',
  patient:         'patients',
  pharmacy_staff:  'pharmacy staff',
  pharmacy:        'pharmacy staff',
  laboratory:      'laboratory staff',
  lab_staff:       'laboratory staff',
  radiology:       'radiology staff',
  radiology_staff: 'radiology staff',
  ambulance_staff: 'ambulance staff',
  org_admin:       'organisation administrators',
}

function describeAllowedRoles(allowed) {
  if (!allowed || allowed.length === 0) return null
  const labels = Array.from(new Set(allowed.map((r) => ROLE_LABELS[r] || r)))
  if (labels.length === 1) return labels[0]
  if (labels.length === 2) return `${labels[0]} or ${labels[1]}`
  return `${labels.slice(0, -1).join(', ')}, or ${labels[labels.length - 1]}`
}

export default function Unauthorized() {
  const { user, signOut } = useAuth()
  const location = useLocation()
  // RequireRole now passes { allowed: [...] } via location.state so we
  // can name exactly who the page is restricted to. Falls back to a
  // generic message when the page is reached directly (e.g. by URL).
  const allowed = location.state?.allowed
  const allowedLabel = describeAllowedRoles(allowed)

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-sm bg-white rounded-xl shadow-sm border border-slate-200 p-6 text-center">
        <h1 className="text-lg font-semibold text-wantok-800">Access restricted</h1>
        <p className="text-sm text-slate-500 mt-2">
          {!user ? (
            'You are not signed in.'
          ) : allowedLabel ? (
            <>This page is restricted to {allowedLabel} only.</>
          ) : (
            <>This page is not available for your account role.</>
          )}
        </p>
        <div className="mt-4 flex items-center justify-center gap-2">
          <Link to="/login" className="text-sm underline text-wantok-700">Back to sign in</Link>
          {user && <button onClick={signOut} className="text-sm underline text-slate-500">Sign out</button>}
        </div>
      </div>
    </div>
  )
}
